import React from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { EnhancementRateService, CorporationTaxRateService, NIThresholdsService, NIRatesService, CreditRateService } from '@services/rates';
import { RATES_SCHEME } from '../constants';
import Rate from '@rd-web-markets/shared/dist/rate/Rate';
export default function Rates() {
  const [enhancementRates, setenhancementRates] = useState(null);
  const [creditRates, setCreditRates] = useState(null);
  const [corporationRates, setCorporationRates] = useState(null);
  const [niThresholds, setNIThresholds] = useState(null);
  const [niRates, setNIRates] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    Promise.all([EnhancementRateService.all(), CreditRateService.all(), CorporationTaxRateService.all(), NIThresholdsService.all(), NIRatesService.all()]).then(result => {
      const [enhancementRatesResult, creditRatesResult, corporationRatesResult, niThresholdsResult, niRatesResult] = result;
      setenhancementRates(enhancementRatesResult);
      setCorporationRates(corporationRatesResult);
      setNIThresholds(niThresholdsResult);
      setNIRates(niRatesResult);
      setCreditRates(creditRatesResult);
    }).catch(err => dispatch(handleError(err)));
  }, [dispatch]);
  const rateTitles = Object.keys(RATES_SCHEME);
  const rateData = [enhancementRates, creditRates, corporationRates, niThresholds, niRates];
  const callbackData = [{
    service: EnhancementRateService,
    setter: setenhancementRates
  }, {
    service: CreditRateService,
    setter: setCreditRates
  }, {
    service: CorporationTaxRateService,
    setter: setCorporationRates
  }, {
    service: NIThresholdsService,
    setter: setNIThresholds
  }, {
    service: NIRatesService,
    setter: setNIRates
  }];
  return /*#__PURE__*/React.createElement(Row, null, rateTitles.map((title, i) => {
    if (rateData[i]) {
      return /*#__PURE__*/React.createElement(Col, {
        key: "rates-".concat(title),
        lg: 4
      }, /*#__PURE__*/React.createElement(Rate, {
        title: title,
        rates: rateData[i],
        service: callbackData[i].service,
        onChange: () => {
          callbackData[i].service.all().then(res => {
            callbackData[i].setter(res);
          });
        }
      }));
    } else {
      return '';
    }
  }));
}